import { Integration } from '@futrli-sdk/app-store';

export const findIntegrationById = (integrations: Integration[], integrationId: string) => {
  return integrations.find((integration: Integration) => integration.id === integrationId);
};

export const filterIntregationsByTag = (integrations: Integration[], tag: string) =>
  integrations.filter(integration => integration.tags.includes(tag) && !integration.slug.includes('mock'));
